<template>
    <div class="paddingBox">
        <div class="d-flex align-items-center justify-content-between mb-20">
            <h2 class="mb-0">Zhrnutie registrácie</h2>
        </div>
        <div class="rounded-box --whiteBg p-50">
            <p class="text-uppercase mb-20"><b class="text-dark">Informácie o kolektíve</b></p>
            <aside class="kolektiv-meta mb-20">
                <p class="koletiv-name mb-0"><b class="text-dark">{{ form.pouzivatel_name }}</b></p>
                <p class="kolektiv-email mb-0">{{ form.pouzivatel_email }}</p>
                <p class="kolektiv-password">
                    <template v-if="showPassword">{{ form.pouzivatel_password }}</template>
                    <template v-else v-for="index in form.pouzivatel_password.length">*</template>
                    <span class="icon icon--eye text-icon ml-10 cursor-pointer" @click="showPassword=!showPassword"></span>
                </p>
            </aside>
            <table class="kolektiv-info mb-50">
                <tr>
                    <th width="145">Typ kolektívu</th>
                    <td>{{ form.pouzivatel_rocnik === 0 ? 'Škôlka' : 'Škola' }}</td>
                </tr>
<!--                <tr>-->
<!--                    <th width="145">Kraj</th>-->
<!--                    <td>{{ form.pouzivatel_kraj }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                    <th width="145">Okres</th>-->
<!--                    <td>{{ form.pouzivatel_okres }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                    <th width="145">Mesto / Obec</th>-->
<!--                    <td>{{ form.pouzivatel_obec }}</td>-->
<!--                </tr>-->
                <tr>
                    <th width="145">Škola</th>
                    <td>{{ form.pouzivatel_skola.cely_nazov }}</td>
                </tr>
                <tr v-if="form.pouzivatel_rocnik">
                    <th width="145">Ročník</th>
                    <td>{{ form.pouzivatel_rocnik }}</td>
                </tr>
            </table>
            <p class="text-uppercase mb-20"><b class="text-dark"><span class="text-primary">{{ form.pouzivatel_ziaci.length }}</span> pridaných žiakov</b></p>

            <ul class="ziaci">
                <li v-for="(ziak,index) in form.pouzivatel_ziaci" :key="index">
                    <span class="icon icon--user mr-10 text-icon"></span>{{ ziak }}
                </li>
            </ul>

            <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit( submit )">
                <div class="form-row">
                    <div class="col-md-12">
                        <div class="separator"></div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12">
                        <validation-provider :rules="{ required: { allowFalse: false } }" name="Súhlas s pravidlami súťaže" v-slot="{ valid, errors }">
                            <div class="custom-control custom-checkbox mb-2" :class="{'is-error': errors.length }">
                                <input type="checkbox" class="custom-control-input" id="customCheck1-kolektiv" v-model="form.pouzivatel_suhlas_pravidla_pouzivania">
                                <label class="custom-control-label" for="customCheck1-kolektiv">
                                    Mám záujem o registráciu na stránke adoptujkravicku.sk a o účasť v súťaži, ktorej organizácia sa spravuje
                                    <a target="_blank" href="https://www.adoptujkravicku.sk/engine/wp-content/uploads/2017/08/Adoptujkravicku-pravidla-sutaze-REV19082021.pdf">Pravidlami súťaže</a>.*
                                </label>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </div>
                        </validation-provider>

                        <validation-provider :rules="{ required: { allowFalse: false } }" name="Súhlas so spracúvaním osobných údajov" v-slot="{ valid, errors }">
                            <div class="custom-control custom-checkbox mb-2" :class="{'is-error': errors.length }">
                                <input type="checkbox" class="custom-control-input" id="customCheck2-kolektiv" v-model="form.pouzivatel_suhlas_osobne_udaje">
                                <label class="custom-control-label" for="customCheck2-kolektiv">
                                    Súhlasím so spracúvaním mojich osobných údajov za podmienok uvedených v
                                    <a target="_blank" href="https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/">Pravidlách ochrany osobných údajov</a>
                                    spojených s prevádzkou webovej stránky adoptujkravičku.sk.*
                                </label>
                                <span class="text-danger">{{ errors[0] }}</span>
                            </div>
                        </validation-provider>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck3-kolektiv" v-model="form.pouzivatel_suhlas_marketing">
                            <label class="custom-control-label" for="customCheck3-kolektiv">
                                Súhlasím so zasielaním marketingových informácií o slovenskom mlieku a mliečnych výrobkoch rôznych slovenských výrobcov na môj e-mail za podmienok uvedených v
                                <a target="_blank" href="https://www.adoptujkravicku.sk/pravidla-ochrany-osobnych-udajov/">Pravidlách ochrany osobných údajov</a>
                                spojených s prevádzkou webovej stránky adoptujkravičku.sk.
                            </label>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-12">
                        <div class="separator"></div>
                    </div>
                </div>

                <slot name="error-message"></slot>

                <div class="form-row mb-0">
                    <div class="col-12 col-md-12 text-right">
                        <div class="d-flex align-items-center justify-content-between">
                            <span @click="$emit('updateStep', 'zoznam')" class="text-primary text-underline cursor-pointer">Späť na zoznam žiakov</span>
                            <button type="submit" class="btn --primary">odoslať registráciu</button>
                        </div>
                    </div>
                </div>
            </form>
            </validation-observer>

        </div>
    </div>

</template>



<script>
    export default {
        props: {
            form: {
                type: Object,
                required: true
            }
        },
        computed: {},
        data() {
            return {
                showPassword: false
            }
        },
        methods: {
            submit() {
                this.$emit('submitForm')
            }
        }
    }
</script>
